<template>
    <div class="offerings-container">
        <!-- Access Restricted Dialog -->
        <div class="modal fade" id="accessRestrictedModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Access Restricted</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This company is no longer active on DealPoint. As a result, past investments and documents are no longer available. Please contact your investment representative for assistance.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="offeringLoaded">
            <div v-for="(emdOffering, id) in emdOfferings" :key="`emd-offering-${id}`">
                <h4>
                    <div class="emd-row">
                        <div class="emd-row-title mb-0">{{ emdOffering.emdName }}</div>
                        <button class="btn btn-link ml-3 emd_collapse_button" type="button" @click="toggleCollapse(id)"
                            :class="{ 'collapsed': isCollapsed(id) || emdOffering.isDisabled }"
                            :aria-expanded="(isCollapsed(id) || emdOffering.isDisabled) ? 'false' : 'true'" :aria-controls="'collapse-' + `emd-offering-${id}`">
                            <i v-if="emdOffering.isDisabled" class="fa fa-chevron-up"></i>
                            <i v-else :class="isCollapsed(id) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                        </button>
                    </div>
                </h4>
                <div v-if="!emdOffering.isDisabled" :class="{ 'collapse': isCollapsed(id) }" :id="'collapse-' + `emd-offering-${id}`">
                    <table class="table dataroom">
                        <tr v-for="(offering, index) in emdOffering.offerings" class="emd-row-offering" :key="'offering-' + index">
                            <td>
                                {{ offering.name }}
                            </td>
                            <td>
                                <a class="btn btn-default subscribe-button" :href="`/${offering.slug}/data-room`">
                                    Visit
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="text-center" v-else>
            <img src="../../images/loader.gif" height="100px" width="100px" />
            <p>Please wait...</p>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';

export default {
    name: "MyOfferingsPage",
    data() {
        return {
            error: '',
            offeringLoaded: false,
            emdOfferings: [],
            collapsedSections: []
        };
    },
    mounted() {
        this.getOfferingGroupByEMDS();
    },
    methods: {
        async getOfferingGroupByEMDS() {
            const emdOfferingsLink = `/emd-offerings`;
            try {
                const response = await axios.get(emdOfferingsLink);
                const responseData = response.data;
                const groupedOfferings = responseData.emdOfferings.reduce(
                    (grouped, offering) => {
                        const id = offering.emd_id;
                        const emdName = offering.emd_name;
                        const isDisabled = offering.is_disabled || false;
                        
                        if (!grouped[id]) {
                            grouped[id] = {
                                emdName,
                                isDisabled,
                                offerings: []
                            };
                        }
                        
                        // Only add offerings if EMD is not disabled
                        if (!isDisabled) {
                            grouped[id].offerings.push(offering);
                        }
                        
                        return grouped;
                    },
                    {}
                );
                this.emdOfferings = Object.values(groupedOfferings);
                this.offeringLoaded = true;
                return responseData;
            } catch (error) {
                this.error = error;
                this.offeringLoaded = true;
            }
        },
        toggleCollapse(id) {
            const emdOffering = this.emdOfferings.find(emd => emd.id === id || this.emdOfferings.indexOf(emd) === id);
            
            // Show access restricted modal for disabled EMDs
            if (emdOffering && emdOffering.isDisabled) {
                $('#accessRestrictedModal').modal('show');
                return;
            }
            
            // Normal toggle logic for active EMDs
            if (this.isCollapsed(id)) {
                this.collapsedSections = this.collapsedSections.filter(
                    emdId => emdId !== id
                );
            } else {
                this.collapsedSections.push(id);
            }
        },
        isCollapsed(id) {
            return this.collapsedSections.includes(id);
        }
    }
};
</script>
